<template>
  <Content class="goodsBox">
    <Button type="primary" style="margin-bottom: 24px" @click="show()">
      添加
    </Button>
    <Form id="searchForm" :model="formItem" :label-width="80" inline>
      <FormItem label="区域名称">
        <Input v-model="formItem.key" placeholder="模糊搜索" clearable />
      </FormItem>
      <FormItem :label-width="20">
        <Button type="primary" @click="search">查询</Button>
        <Button style="margin-left: 8px" @click="clear">重置</Button>
      </FormItem>
    </Form>
    <Table
      :columns="columns"
      :data="tableData"
      :height="tablesHeight"
      border
    ></Table>
    <Page
      class="table_page_css"
      v-show="total"
      :total="total"
      :current="searchInfo.pageNo"
      :page-size="searchInfo.pageSize"
      :page-size-opts="pageSizeOpts"
      @on-change="pageNoChange"
      @on-page-size-change="pageSizeChange"
      show-sizer
      show-elevator
      show-total
    />
    <AddUpdate @reload="getList" ref="AddUpdate"></AddUpdate>
  </Content>
</template>
<script>
import { getAreaList, deleteArea, getAreaListByRole } from '@/api/area'
import AddUpdate from './AreaAddUpdate'
export default {
  name: 'Roles',
  components: {
    AddUpdate,
  },
  data() {
    return {
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center',
        },
        {
          title: '区域名称',
          key: 'area_name',  // 修改为下划线形式
        },
        {
          title: '区域描述',
          key: 'area_desc',  // 修改为下划线形式
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                  },
                  on: {
                    click: () => {
                      this.show(params.row)
                    },
                  },
                },
                '编辑',
              ),
              h(
                'Poptip',
                {
                  props: {
                    confirm: true,
                    transfer: true,
                    title: '您确认删除这条内容吗？',
                  },
                  on: {
                    'on-ok': () => {
                      this.remove(params.row._id)
                    },
                  },
                },
                [
                  h(
                    'Button',
                    {
                      props: {
                        type: 'error',
                        size: 'small',
                      },
                      style: {
                        marginRight: '5px',
                      },
                    },
                    '删除',
                  ),
                ],
              ),
             
            ])
          },
        },
      ],
      tableData: [],
      total: 0,
      searchInfo: {
        pageNo: 1,
        pageSize: 5,
      },
      pageSizeOpts: [1, 2, 5, 10],
      formItem: {
        key: '',
      },
      tablesHeight: 0,
    }
  },
  methods: {
    // 设置表格高度的函数
setTablesHeight() {
  let aH = 0 // 初始化变量aH，用于存储计算后的表格高度
  let oA = document.getElementById('app') // 获取id为'app'的DOM元素
  let oH = oA.clientHeight || oA.offsetHeight // 获取该元素的客户区高度或总高度
  let sA = document.getElementById('searchForm') // 获取搜索表单的DOM元素
  let sH = sA.clientHeight || sA.offsetHeight // 获取搜索表单的客户区高度或总高度
  aH = oH - sH - 265 // 计算表格高度，减去搜索表单高度和固定值265
  this.tablesHeight = aH // 将计算后的高度赋值给tablesHeight属性
},

// 获取列表数据的函数
getList() {
  getAreaList(this.searchInfo) // 调用getAreaList API获取区域列表
    .then((res) => { // 处理成功的响应
      if (res.data.code === 200) { // 如果响应码为200，表示成功
        const data = res.data // 从响应数据中提取数据
        this.tableData = data.data // 更新表格数据
        this.total = data.total // 更新总记录数
      } else {
        this.$Message.error(res.data.msg) // 如果响应码不是200，显示错误消息
      }
    })
    .catch((err) => { // 处理错误的响应
      this.$Message.error(err) // 显示错误消息
    })
},

// 搜索函数
search() {
  this.searchInfo = { // 更新搜索信息
    key: this.formItem.key, // 搜索关键字
    pageNo: 1, // 重置页码为1
    pageSize: this.searchInfo.pageSize, // 保持页大小不变
  }
  this.getList() // 调用getList函数重新获取数据
},

// 清除搜索条件并重新获取列表数据的函数
clear() {
  this.formItem = { // 重置表单数据
    key: '', // 清空搜索关键字
  }
  this.searchInfo = { // 重置搜索信息
    pageNo: 1, // 重置页码为1
    pageSize: 5, // 重置页大小为5
  }
  this.getList() // 调用getList函数重新获取数据
},

// 显示添加或更新模态框的函数
show(params) {
  if (params) { // 如果params存在，表示是更新操作
    this.$refs.AddUpdate.init(params) // 调用AddUpdate组件的init方法并传入params
  } else { // 如果params不存在，表示是添加操作
    this.$refs.AddUpdate.init() // 调用AddUpdate组件的init方法
  }
},

// 删除区域的函数
remove(_id) {
  deleteArea({ _id: _id }) // 调用deleteArea API删除区域
    .then((res) => { // 处理成功的响应
      if (res.data.code === 200) { // 如果响应码为200，表示删除成功
        this.$Message.success('删除成功') // 显示成功消息
        this.getList() // 调用getList函数重新获取数据
        // 重新获取区域列表并更新Vuex store，以便车辆管理界面能显示最新区域
        this.updateAreaStore()
      } else {
        this.$Message.error(res.data.msg) // 如果响应码不是200，显示错误消息
      }
    })
    .catch((err) => { // 处理错误的响应
      this.$Message.error(err) // 显示错误消息
    })
},

// 更新Vuex store中的区域列表
async updateAreaStore() {
  try {
    const res = await getAreaListByRole()
    if (res.data.code === 200) {
      // 更新Vuex store中的区域数据
      this.$store.commit('setareas', JSON.stringify(res.data.data))
      console.log('区域列表已更新到Vuex store')
    } else {
      console.error('获取区域列表失败:', res.data.msg)
    }
  } catch (error) {
    console.error('更新区域列表失败:', error)
  }
},

// 页码改变的函数
pageNoChange(current) {
  this.searchInfo.pageNo = current // 更新页码
  this.getList() // 调用getList函数重新获取数据
},

// 页大小改变的函数
pageSizeChange(val) {
  this.searchInfo.pageNo = 1 // 重置页码为1
  this.searchInfo.pageSize = val // 更新页大小
  this.getList() // 调用getList函数重新获取数据
},

  },
  mounted() {
    this.getList()
    setTimeout(() => {
      this.setTablesHeight()
    }, 50)
    window.onresize = () => {
      this.setTablesHeight()
    }
  },
}
</script>
<style lang="less" scoped>
.goodsBox {
  .ivu-form-inline .ivu-form-item {
    width: 267px;
  }
}
</style>
